import { render, staticRenderFns } from "./129.vue?vue&type=template&id=5c39fc4d&scoped=true&"
var script = {}
import style0 from "./129.vue?vue&type=style&index=0&id=5c39fc4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39fc4d",
  null
  
)

export default component.exports